import GetMenu from '@/app_gql/common/menus/GetMenu.gql';
import { GetData } from '@/app_lib/getData';
import { Menu } from '@/app_lib/types/Menu';

interface GetMenuParams {
  location?: string;
  slug?: string;
  first?: number;
}

export async function getMenu({ location, slug, first = 100 }: GetMenuParams) {
  const data = await GetData.content<Menu>(GetMenu, { first, location, slug });

  if (!data.success) {
    throw new Error('HTTP Error');
  }

  const validatedData = await Menu.safeParseAsync(data.value);

  if (!validatedData.success) {
    throw new Error(`Validation Error: ${validatedData.error}`);
  }

  return validatedData.data.menus.nodes[0].menuItems.nodes;
}
